import { FC } from 'react';
import { Link } from 'react-router-dom';
import { getRoute } from '@/routes/Routes.helpers';
import ImgWidLogo from '@/assets/svg/img_wid_logo.svg?react';
import LinkToProfile from '@/components/elems/LinkToProfile/LinkToProfile.component';
import styles from '@/components/widgets/HeaderWidget/MainHeader/MainHeader.module.scss';
import SearchWidget from '@/components/widgets/SearchWidget/SearchWidget.component';

const MainHeader: FC = () => {
    const { path } = getRoute('home') || {};

    return (
        <div className={styles.mainHeaderWrapper}>
            <div className={styles.leftStub} />
            <Link to={path} aria-label="WID logo" className={styles.logo}>
                <ImgWidLogo />
            </Link>
            <div className="flc">
                <SearchWidget
                    className={`flc ${styles.searchWidget}`}
                    isNeedHighlight
                />
                <LinkToProfile isNeedHighlight />
            </div>
        </div>
    );
};

export default MainHeader;
